import axios, { AxiosResponse } from 'axios';
import { format } from 'date-fns';
import { apisiseci } from './api';

interface Dependente {
  cpf: string;
  nome: string;
  data_nascimento: Date | string;
  grau_parentesco: string;
}

interface ComprovanteAtendimentoParams {
  ticket: string;
  type: 'interno' | 'organico' | 'presencial';
}

interface AtenderOnlinePayload {
  servico: number;
  unidade: string;
  titulo: string;
  conteudo: string;
  data: string;
  setor: string;
  tipo: string;
  hora: string;
  para_dependente?: boolean;
  dependente?: Dependente | null;
}

export const atenderOnline = (
  token: string,
  servico: number,
  unidade: string,
  titulo: string,
  conteudo: string,
  setor: string,
  tipo: string,
  date: Date,
  hora: string,
  para_dependente?: boolean,
  dependente?: Dependente | null,
): Promise<AxiosResponse> => {
  const data = format(date, 'yyyy-MM-dd');
  const payload: AtenderOnlinePayload = {
    servico,
    unidade,
    titulo,
    conteudo,
    data,
    setor,
    tipo,
    hora,
    para_dependente,
  };

  if (para_dependente && dependente) {
    payload.dependente = {
      cpf: dependente.cpf,
      nome: dependente.nome,
      data_nascimento: format(Number(dependente.data_nascimento), 'yyyy-MM-dd'),
      grau_parentesco: dependente.grau_parentesco,
    };
  }

  return apisiseci.post('atendimento/solicitar/', payload, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });
};

export const checarHorarios = (
  date: Date,
  unity: string,
  serviceID: number,
): Promise<AxiosResponse> => {
  const dateScheduler = format(date, 'yyyy-MM-dd');

  return apisiseci
    .get(`atendimento/checar_horarios/?data=${dateScheduler}&servico=${serviceID}&unidade=${unity}`);
};

export const anexarArquivo = (
  token: string,
  titulo: string,
  descricao: string,
  arquivo: File,
  topico: string,
  resposta?: string,
): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append('titulo', titulo);
  formData.append('descricao', descricao);
  formData.append('arquivo', arquivo);
  formData.append('resposta', resposta || '');
  formData.append('topico', topico);
  return apisiseci.post('atendimento/anexar_topico/', formData, {
    headers: {
      'content-type': 'multipart/form-data',
      Authorization: `Token ${token}`,
    },
  });
};

export const anexarArquivoResposta = (
  token: string,
  titulo: string,
  descricao: string,
  arquivo: File,
  resposta: string,
): Promise<AxiosResponse> => {
  const formData = new FormData();
  formData.append('titulo', titulo);
  formData.append('descricao', descricao);
  formData.append('arquivo', arquivo);
  formData.append('resposta', resposta);
  return apisiseci.post('atendimento/anexar_resposta/', formData, {
    headers: {
      'content-type': 'multipart/form-data',
      Authorization: `Token ${token}`,
    },
  });
};

export const atendimentoPorId = (token: string, id: string): Promise<AxiosResponse> => apisiseci
  .get(`atendimento/meus_atendimentos/${id}/`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
    });

export const enviarMensagem = (token: string, id: string, message: string, haveAnexo?: boolean): Promise<AxiosResponse> => apisiseci
  .post('atendimento/responder/', {
    topico: id,
    conteudo: message,
    anexo: haveAnexo,
  }, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

export const meusAtendimentos = (token: string, page: number, params?: { status: string }): Promise<AxiosResponse> => apisiseci
  .get(`atendimento/meus_atendimentos/?page=${page}`,
    {
      headers: {
        Authorization: `Token ${token}`,
      },
      params,
    });

export const cancelar = (token: string, id: string): Promise<AxiosResponse> => apisiseci
  .put(`atendimento/cancelar/${id}/`, {
    id,
    status: 'Cancelado',
  }, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

export const mensagemLida = (token: string, resposta_id: number): Promise<AxiosResponse> => apisiseci
  .put(`atendimento/marcar_resposta/${resposta_id}/`, {
    lido: true,
  }, {
    headers: {
      Authorization: `Token ${token}`,
    },
  });

  export const comprovanteAtendimento = ({
    ticket,
    type,
  }: ComprovanteAtendimentoParams): Promise<AxiosResponse> => {
    let route = '';
    switch (type) {
      case 'interno':
        route = `/agendamento/agendamentos_internos_ticket/`;
        break;
      case 'organico':
        route = `/diario/atendimentos_ticket/`;
        break;
      case 'presencial':
        route = `/agendamento/agendamentos_ticket/`;
        break;
      default:
        throw new Error('Tipo inválido para o comprovante de atendimento.');
    }
  
    return apisiseci.get(route, {
      params: {
        ticket,
      },
    });
  };